// Simplified unified configuration interface
let authConfig = null;
const initializeAuth = async (config)=>{
    // Validate required properties
    const required = [
        'userPoolId',
        'userPoolClientId',
        'region'
    ];
    const missing = required.filter((prop)=>!config[prop]);
    if (missing.length > 0) {
        throw new Error(`UniversalAuthConfig is missing required properties: ${missing.join(', ')}`);
    }
    // Store the configuration
    authConfig = config;
    // Automatically configure Amplify
    try {
        const { configureCognito } = await import('./cognito/cognito.helper.js');
        configureCognito();
    } catch (error) {
        console.error('❌ Universal Auth: Failed to initialize:', error);
        // Use the error handler if provided
        if (config.onError) {
            config.onError(error, {
                context: 'initializeAuth',
                message: 'Failed to configure Amplify during initialization'
            });
        }
        throw error;
    }
};
const getAuthConfig = ()=>{
    if (!authConfig) {
        throw new Error('Auth not initialized. Call initializeAuth() first.');
    }
    return authConfig;
};
// Helper to get the authentication flow type with default
const getAuthFlowType = ()=>{
    const config = getAuthConfig();
    return config.authFlowType || 'USER_PASSWORD_AUTH';
};
// Helper to get the Amplify-compatible authentication flow type
const getAmplifyAuthFlowType = ()=>{
    const flowType = getAuthFlowType();
    // Map our CUSTOM_AUTH to Amplify's CUSTOM_WITHOUT_SRP
    if (flowType === 'CUSTOM_AUTH') {
        return 'CUSTOM_WITHOUT_SRP';
    }
    return flowType;
};

export { getAmplifyAuthFlowType, getAuthConfig, getAuthFlowType, initializeAuth };
//# sourceMappingURL=config.js.map
